import { Avatar, Button, Card, Col, Grid, List, Row, Typography } from 'antd'
import React, { useEffect, useState } from 'react'

import Sider from 'antd/es/layout/Sider';
import { TiWeatherPartlySunny } from 'react-icons/ti'
import { useLocation } from 'react-router-dom';

const data = [
    {
        title: "Marcelo soares",
    },
    {
        title: "Marcelo soares",
    },
    {
        title: "Marcelo soares",
    },
    {
        title: "Marcelo soares",
    },
];

const { useBreakpoint } = Grid;
export default function BulletinBoard() {

    const breakpoints = useBreakpoint();
    const { pathname } = useLocation();
    const [viewPortWidth, setViewPortWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setViewPortWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    if (pathname !== '/') return null;

    return (
        <div
            style={{
                maxWidth: !(viewPortWidth <= 1305) ? "300px" : '100%',
                padding: '10px'
            }}
        >

            <div
                style={{
                    backgroundColor: "#05204e",
                    width: "100%",
                    padding: "53px 10px",
                    textAlign: "center",
                    borderRadius: "3px",
                    marginBottom: "30px",
                }}
            >
                <Typography className="title-ask">Não fique com dúvidas</Typography>
                <Typography className="subtitle-ask">
                    Utilize o canal correto para postar suas dúvidas e receber seu
                    suporte em até 72h úteis (normalmente a resposta virá no mesmo dia).
                </Typography>
                <Button
                    style={{
                        backgroundColor: "#FC5E30",
                        borderRadius: "3px",
                        fontSize: "16px",
                        color: "#FFF",
                    }}
                >
                    <span style={{ padding: "0 20px" }}>Deixe sua dúvida</span>
                </Button>
            </div>

            <div
                style={{
                    backgroundColor: "#00CCFF",
                    width: "100%",
                    padding: "16px 5px",
                    borderRadius: "3px",
                    marginBottom: "40px",
                }}
            >
                <Row align="bottom" style={{ marginBottom: "19px" }}>
                    <TiWeatherPartlySunny size={20} color="#FFF" />
                    <Typography className="weather-title">
                        Segunda, 12 de dezembro
                    </Typography>
                </Row>
                <Row>
                    <Col lg={12}>
                        <Typography
                            className="weather-title"
                            style={{ marginBottom: "8px" }}
                        >
                            Prova I
                        </Typography>
                        <Typography
                            className="weather-title"
                            style={{ marginBottom: "8px" }}
                        >
                            Módulo 1
                        </Typography>
                        <Typography className="weather-title">
                            Prazo final: 13/12/2022
                        </Typography>
                    </Col>
                    <Col lg={12} style={{ borderLeft: "1px solid #FFF" }}>
                        <Typography
                            className="weather-title"
                            style={{ marginBottom: "8px" }}
                        >
                            Prova II
                        </Typography>
                        <Typography
                            className="weather-title"
                            style={{ marginBottom: "8px" }}
                        >
                            Módulo 1
                        </Typography>
                        <Typography className="weather-title">
                            Prazo final: 24/01/2023
                        </Typography>
                    </Col>
                </Row>
            </div>

            <div>
                <Typography className="warnings-title">Mural de avisos</Typography>
                <Card style={{ borderBottom: '8px solid #dc6f10' }}>
                    <List
                        itemLayout="horizontal"
                        dataSource={data}
                        renderItem={(item) => (
                            <List.Item>
                                <List.Item.Meta
                                    avatar={
                                        <Avatar src="https://www.w3schools.com/w3images/avatar2.png" />
                                    }
                                    title={
                                        <Row justify="space-between" align='middle'>
                                            {item.title}
                                            <Typography
                                                style={{
                                                    border: "1px solid #11BC2D",
                                                    fontSize: "8px",
                                                    color: "#11BC2D",
                                                    padding: "2px 4px",
                                                    borderRadius: "7px"
                                                }}
                                            >
                                                Monitor
                                            </Typography>
                                        </Row>
                                    }
                                    description={"Nova ferramenta de interação..."}
                                />
                            </List.Item>
                        )}
                    />
                </Card>
            </div>
        </div>
    )
}
